import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const POST_PAYMENT_TOKEN = new InjectionToken<Observable<boolean>>('POST_PAYMENT_TOKEN');
